let pubToggle  = null
let pubContent = null


export function initialize() {

  // If the window is 768px or wider, stop everything.
  if (window.innerWidth >= 768) return

  // Gather up all of the elements we'll work on.
  pubToggle  = document.querySelector('[data-pub-tools-toggle]')
  pubContent = document.querySelector('[data-pub-tools-content]')

  // Stop everything if any of the above elements do not exist.
  if (!pubToggle || !pubContent) return

  // Initialize the page's default state: show the button & hide the content.
  pubToggle.removeAttribute('hidden')
  pubContent.setAttribute('hidden', 'true')

  // Move onto adding event listener(s).
  addListeners()

}


export function addListeners() {
  pubToggle.addEventListener('click', handlePubContent, false)
}


export function handlePubContent() {
  pubToggle.classList.toggle('is-selected')

  if (pubContent.getAttribute('hidden')) {
    pubContent.removeAttribute('hidden')
  } else {
    pubContent.setAttribute('hidden', 'true')
  }

}
